export default __webpack_public_path__ + "static/media/slider2-3items.93d79585.svg";